export const countryLookup: Record<string, { nameKey: string; flag: string }> = {
  EU: { nameKey: "country.europeanUnion", flag: "🇪🇺" },
  AT: { nameKey: "country.austria", flag: "🇦🇹" },
  BE: { nameKey: "country.belgium", flag: "🇧🇪" },
  BG: { nameKey: "country.bulgaria", flag: "🇧🇬" },
  CY: { nameKey: "country.cyprus", flag: "🇨🇾" },
  CZ: { nameKey: "country.czechRepublic", flag: "🇨🇿" },
  DE: { nameKey: "country.germany", flag: "🇩🇪" },
  EE: { nameKey: "country.estonia", flag: "🇪🇪" },
  EL: { nameKey: "country.greece", flag: "🇬🇷" },
  ES: { nameKey: "country.spain", flag: "🇪🇸" },
  FI: { nameKey: "country.finland", flag: "🇫🇮" },
  FR: { nameKey: "country.france", flag: "🇫🇷" },
  HR: { nameKey: "country.croatia", flag: "🇭🇷" },
  HU: { nameKey: "country.hungary", flag: "🇭🇺" },
  IE: { nameKey: "country.ireland", flag: "🇮🇪" },
  IT: { nameKey: "country.italy", flag: "🇮🇹" },
  LT: { nameKey: "country.lithuania", flag: "🇱🇹" },
  LU: { nameKey: "country.luxembourg", flag: "🇱🇺" },
  LV: { nameKey: "country.latvia", flag: "🇱🇻" },
  DK: { nameKey: "country.denmark", flag: "DK" },
  MT: { nameKey: "country.malta", flag: "🇲🇹" },
  NL: { nameKey: "country.netherlands", flag: "🇳🇱" },
  PL: { nameKey: "country.poland", flag: "🇵🇱" },
  PT: { nameKey: "country.portugal", flag: "🇵🇹" },
  RO: { nameKey: "country.romania", flag: "🇷🇴" },
  SE: { nameKey: "country.sweden", flag: "🇸🇪" },
  SI: { nameKey: "country.slovenia", flag: "🇸🇮" },
  SK: { nameKey: "country.slovakia", flag: "🇸🇰" },
};

